import { mergeClassNames } from '../../../utils/commonFunctions'
import './Skeleton.scss'

interface ComponentProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string
}

const Skeleton: React.FC<ComponentProps> = ({ className = '', ...rest }) => {
    return (
        <div className={mergeClassNames(`custom__skeleton`, className)} {...rest} />
    )
}

export default Skeleton